import { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Card, Button, Form } from "react-bootstrap";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../css/swiper.css';
import { Link } from 'react-router-dom'
import { Navigation, Pagination } from 'swiper/modules';
import { getLatestPressAction } from "../../apis/apiAction";




const LatestPress = () => {

    const [pressData, setPressData] = useState([]);
    useEffect(() => {
      getLatestPress();
    }, []);
  
    const getLatestPress = async () => {
      const res = await getLatestPressAction();
      setPressData(res.data);
    };

    return (
        <>
            <Container>
                <Row className="justify-content-center text-center ">
                    <Col lg={12} className="mb-5">
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={10}
                            breakpoints={{
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                1024: {
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                },
                            }}
                            navigation={true}
                            loop={true}
                            modules={[Navigation]}
                            className="mySwiper"
                        >
                            {pressData.map(
                                (press, index) =>
                                    index < 5 && (
                                        <SwiperSlide>
                                            <div className="">
                                                <Card className="lightBlueCard rounded-5 p-3 text-start">
                                                <Card.Img variant="top" src="assets/images/press/image2.png" />
                                                    <Card.Body>
                                                    <Link to={press.link} target="_blank">
                                                        <Card.Title className="text-white">{press.title}</Card.Title>
                                                        <div className="text-primary fw-semibold my-3">{press.publishedDate}</div>
                                                        <Card.Text className="mb-4">
                                            </Card.Text>
                                            </Link>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </SwiperSlide>
                                    )
                                )}
                        </Swiper>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
export default LatestPress;
